export class ApiError extends Error {
    status: number;
    details?: unknown;

    constructor(message: string, status: number, details?: unknown) {
        super(message);
        this.status = status;
        this.details = details;
    }
}

const BASE_URL = process.env.REACT_APP_API_URL ?? "http://localhost:4000";
const WORKSPACE_ID = process.env.REACT_APP_WORKSPACE_ID ?? "default-workspace";
const USER_ID = process.env.REACT_APP_USER_ID ?? "default-user";

export async function http<T>(path: string, init?: RequestInit): Promise<T> {
    const res = await fetch(`${BASE_URL}${path}`, {
        ...init,
        headers: {
            "Content-Type": "application/json",
            "x-workspace-id": WORKSPACE_ID,
            "x-user-id": USER_ID,
            ...(init?.headers ?? {}),
        },
    });

    // Express DELETE 204 support
    if (res.status === 204) {
        return undefined as T;
    }

    const text = await res.text();
    const data = text ? JSON.parse(text) : null;

    if (!res.ok) {
        const message = data?.message || data?.error || `Request failed (${res.status})`;
        throw new ApiError(message, res.status, data);
    }

    return data as T;
}
